export default [
  {
    title: '规则ID',
    key: 'ruleId',
    width: 64
  },
  {
    title: '开关',
    key: 'state',
    width: 50
  },
  {
    title: '规则名称',
    key: 'ruleName',
    width: 152
  },
  {
    title: '触发条件',
    key: 'ruleInfo',
    width: 160
  },
  {
    title: '游戏',
    key: 'games',
    width: 200,
    overflow: true
  },
  {
    title: '提醒类型/时间',
    key: 'alertType',
    width: 140
  },
  {
    title: '提醒人员',
    key: 'opIds'
  },
  {
    title: '创建人',
    key: 'opName',
    width: 64
  },
  {
    title: '最后操作人',
    key: 'upOpName',
    width: 84
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 140
  },
  {
    title: '最后暂停/启动时间',
    key: 'lastRpTime',
    width: 140
  },
  {
    title: '操作',
    key: 'control',
    width: 104
  }
]
